import { extractMkt } from './utils';
import { getIsLiveChatEnabled } from './url-pilots';

export const getLiveChatSrc = () => {
  const isLiveChatEnabled = getIsLiveChatEnabled();
  if (!isLiveChatEnabled) {
    return '';
  }
  const mkt = extractMkt();
  if (mkt && mkt.toLowerCase() === 'en-us') {
    return 'https://vsa.services.microsoft.com/en-us/v1.0/?partnerId=f961e078-7730-4bb4-9ac7-ce5e927cd4c3&authType=unauth&initialquery=SuppRoute_Welcome&sendboxdisable=true&flowid=VirtualAgent-ProductLP-EN-US';
  }
  return '';
};

export const getPopupWindowFeatures = ({
  windowObject = window,
  width = 548,
  height = 512,
} = {}) => {
  // calculate center point of parent window
  const centerX = windowObject.screenX + (windowObject.outerWidth / 2);
  const centerY = windowObject.screenY + (windowObject.outerHeight / 2);

  // set left and top so that popup is centered over the parent window
  const left = centerX - (width / 2);
  const top = centerY - (height / 2);

  const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    'popup=yes',
  ];
  return features.join(',');
};
